import { cacheKeyOf, urlCache } from "./cache";
import type { InvalidateProjectAssetUrl } from "./types";

export const invalidateProjectAssetUrl: InvalidateProjectAssetUrl = ({
  projectId,
  key,
}) => {
  urlCache.delete(cacheKeyOf(projectId, key));
};
